module.exports = __webpack_public_path__ + "img/Video-link.8a524883.gif";